import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {
  // AutocompleteInput,
  Edit,
  // ReferenceInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
} from 'react-admin';
import CategoryIcon from '@mui/icons-material/Category';
import CustomDeleteButton from './CustomDeleteButton';
import { AutocompleteStatus } from './AutocompleteStatus';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unRedirectFromModalAction } from '../../redux/creates-action/RedirectFromModalAction';
import FontSize from '../layout/FontSize';
import Color from '../layout/color/Color';



const saveButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: '1px solid',
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  color: Color.Button,
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};

const CategoryCreateToolbar = (props) => {
  const navigate = useNavigate();
  const handleBack = (e) => {
    e.preventDefault();
    navigate('/Category');
  };

  return (
    <Toolbar sx={{ justifyContent: 'space-between' }} {...props}>
      <Button
        startIcon={<KeyboardBackspaceIcon />}
        onClick={handleBack}
        sx={backButton}
      >
        Back
      </Button>
      <SaveButton sx={saveButton} />
    </Toolbar>
  );
};
export const CategoryEdit = (props) => {
  const dispatch = useDispatch();
  const redirectOptions = useSelector((state) => state.redirectModal.data);
  const navigate = useNavigate();
  useEffect(() => {
    if (redirectOptions.redirect) {
      dispatch(unRedirectFromModalAction());
      navigate('/Category');
    }
  }, [redirectOptions.redirect, navigate, dispatch]);
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<CategoryCreateToolbar />}>
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            mb: 2,
          }}
        >
          <Button
            endIcon={<CategoryIcon sx={{ color: Color.Main }} />}
            sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
            size="medium"
          >
            <Typography variant="h3">Edit Category</Typography>
          </Button>
          <CustomDeleteButton />
        </Grid>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <Grid
          sx={{
            display: 'flex',
            p: 3,
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid
            container={true}
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              width: { xs: '100%', md: '80%' },
            }}
          >
            <Grid item xs={0} md={4} lg={2} sx={{ textAlign: 'center' }}></Grid>
            <Grid item xs={12} sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextInput
                      required
                      source="name"
                      label="Name"
                      fullWidth
                      variant="outlined"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box>
                    <TextInput
                      required
                      source="description"
                      label="Description"
                      fullWidth
                      variant="outlined"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{ width: { xs: '100%', md: '80%', lg: '50%' } }}>
                    <AutocompleteStatus source="status" />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
